import axios from "axios";
import Vue from "vue";
import { authRouter, DevBaseURL } from "./routerMaster";
import { Loading } from "element-ui";
import store from "@/store";
// 创建axios实例
const service = axios.create({
  baseURL: DevBaseURL, // REMOTE_SERVER
  timeout: 60000, // 请求超时时间60秒,
});
var loading = null;
// request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers.projectType = "CLOUD";
    const MarketingCloudToken = store.state.user.MarketingCloudToken;
    const currentProject = store.state.user.currentProject;
    if (MarketingCloudToken && currentProject) {
      config.headers["MarketingCloud-Token"] = MarketingCloudToken;
      config.headers.projectId = currentProject.id;
    }
    if (config.isLoading) {
      loading = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    }
    return config;
  },
  (error) => {
    Vue.prototype.$message.error("请求发送失败");
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    loading && loading.close();
    if (response.status == 200) {
      const data = response.data;
      if (data.msg == "success") {
        return data;
      }
      // 用户没有访问权限，数据库无该用户数据
      if (data.code == "401" || data.code == "10021") {
        authRouter();
      }

      //接口是否隐藏 异常提示
      if (!response.config.hideError) {
        data.msg ? Vue.prototype.$message.error(data.msg) : null;
      }
      // 统一处理导出数据（文件流）
      if (response.config.responseType === "blob") {
        if (response.config.commonExport) {
          var text = new Response(response.data).text();
          try {
            text.then((err) => {
              if (response.data.type.includes("json")) {
                const errText = JSON.parse(err);
                Vue.prototype.$message.error(errText.msg);
              }
            });
          } catch (err) {
            console.log("err------", err);
          }
          // 自动获取文件名称
          return Promise.resolve(response);
        } else {
          return response.data;
        }
      }

      return Promise.reject(data.msg);
    }
    Vue.prototype.$message.error("系统繁忙");
    return Promise.reject(response);
  },
  (error) => {
    console.log("error", error);
    loading && loading.close();
    if (error.response) {
      //   错误响应处理
      Vue.prototype.$message.error("系统升级中，请稍后再试");
      return Promise.reject("系统升级中，请稍后再试");
    }
    Vue.prototype.$message.error("请检查您的网络");
    return Promise.reject("请检查您的网络");
  }
);

export default service;
